module.exports = __webpack_public_path__ + "img/2.400bd229.png";